import { canv } from '@/canv/global.js'
import { lightOrDark } from '@/canv/utils.js'
import {toolBase} from '@/tools/toolBase';

import { Group } from '@/group';
import { shapeWidget } from '@/elements/shape.js'
import { selectionManager } from '../cursorTool';


export class shapeTool extends toolBase {

    constructor() {
        super();

        this.subMenuShapes = ["rect", "roundedRect", "circle", "triangle", "rombus", "bubble", "RSkewRect", "arrowRight", "arrowLeft"];
    }

    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.75 12H2.25V20.25C2.25 20.6478 2.40804 21.0294 2.68934 21.3107C2.97064 21.592 3.35218 21.75 3.75 21.75H9.75V20.25H3.75V12ZM21 21.75H12.75C12.6197 21.75 12.4916 21.716 12.3784 21.6514C12.2652 21.5868 12.1708 21.4938 12.1045 21.3816C12.0382 21.2694 12.0022 21.1419 12.0002 21.0116C11.9982 20.8813 12.0302 20.7527 12.093 20.6385L16.218 13.1385C16.2821 13.0203 16.377 12.9218 16.4928 12.8534C16.6085 12.7849 16.7406 12.7492 16.875 12.75C17.1322 12.75 17.3895 12.879 17.532 13.1385L21.657 20.6385C21.7198 20.7527 21.7518 20.8813 21.7498 21.0116C21.7478 21.1419 21.7118 21.2694 21.6455 21.3816C21.5792 21.4938 21.4848 21.5868 21.3716 21.6514C21.2584 21.716 21.1303 21.75 21 21.75ZM14.0182 20.25H19.7318L16.875 15.0563L14.0182 20.25ZM20.25 2.25H12V3.75H20.25V14.244H21.75V3.75C21.75 3.35218 21.592 2.97064 21.3107 2.68934C21.0294 2.40804 20.6478 2.25 20.25 2.25ZM8.25 2.25H3.75C3.35218 2.25 2.97064 2.40804 2.68934 2.68934C2.40804 2.97064 2.25 3.35218 2.25 3.75V8.25C2.25 8.64782 2.40804 9.02936 2.68934 9.31066C2.97064 9.59196 3.35218 9.75 3.75 9.75H8.25C8.64782 9.75 9.02936 9.59196 9.31066 9.31066C9.59196 9.02936 9.75 8.64782 9.75 8.25V3.75C9.75 3.35218 9.59196 2.97064 9.31066 2.68934C9.02936 2.40804 8.64782 2.25 8.25 2.25ZM8.25 8.25H3.75V3.75H8.25V8.25Z" fill="#2C2D32"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Фигуры";
    }

    getToolHotKey() {
        return "S";
    }

    select() {
        super.select();
        this.openSubMenu();
    }

    unselect() {
        super.unselect();
        this.closeSubMenu();
        canv.appInterface.shapeLibraryWindow.hide();
        this.ghost = null;
        this.clickMove = 0;
    }

    openSubMenu() {
        var subMenu = document.createElement('div');
        subMenu.classList.add("shapeTool_subMenu");
        document.body.prepend(subMenu);


        subMenu.innerHTML = this.getSubMenu();

        var modes = document.getElementsByClassName('shapeTool_subMenu_inner_container');
        for(var i = 0; i < modes.length; i++) {
            var mode = modes[i].getAttribute("mode");
            modes[i].removeEventListener('mouseup', this.setMode.bind(this, mode), false);
            modes[i].addEventListener('mouseup', this.setMode.bind(this, mode), false);
        }

        var more = document.getElementsByClassName('shapeTool_subMenu_more')[0];
        more.removeEventListener('mouseup', this.openShapeLibrary.bind(this), false);
        more.addEventListener('mouseup', this.openShapeLibrary.bind(this), false);


        this.locateSubMenu(this.getToolClass(), "shapeTool_subMenu");

        subMenu.style.transform = "translate(0px)";
        subMenu.style.opacity = "1";
    }


    getSubMenu() {
        var items = ``;

        for (var i = 0; i < this.subMenuShapes.length; i++) {
            let ifSelectedClass = this.mode == this.subMenuShapes[i] ? "shapeTool_subMenu_inner_container_selected" : "";
            items += `<div class="shapeTool_subMenu_inner_container ` + ifSelectedClass + `" mode=` + this.subMenuShapes[i] + `>` + canv.shapeStorage.getShape(this.subMenuShapes[i]).getView("shapeToolSubMenu") + `</div>`;
        }

        var template = `
            <div class="shapeTool_subMenu_inner">
            ` + items + `
            </div>
            <div class="shapeTool_subMenu_more"><p>+</p></div>
        `;


        return template;
    }

    closeSubMenu() {
        var subMenu = document.getElementsByClassName('shapeTool_subMenu')[0];
        if (subMenu != undefined) {
            subMenu.outerHTML = "";
        }
    }

    openShapeLibrary() {
        this.closeSubMenu();
        canv.appInterface.shapeLibraryWindow.show();
    }



    // setters

    setMode(mode) {
        this.mode = mode;
        if (canv.shapeStorage.needStroke(mode) && this.borderColor == "transparent") {
            this.borderColor = "black";
        }

        if (canv.shapeStorage.disableFill(mode)) {
            this.color = "transparent";
        }

        let shapesItems = document.getElementsByClassName("shapeTool_subMenu_inner_container");
        for (var i = 0; i < shapesItems.length; i++) {
            shapesItems[i].classList.remove("shapeTool_subMenu_inner_container_selected");
            let mode = shapesItems[i].getAttribute("mode");
            if (this.mode == mode) {
                shapesItems[i].classList.add("shapeTool_subMenu_inner_container_selected");
            }
        }


        this.resetGhost();
        canv.redraw();
    }

    setColor(color) {
        this.color = color;
        this.resetGhost();
    }

    setBorderColor(color) {
        this.borderColor = color;
        this.resetGhost();
    }

    setBorderDashType(borderDashType) {
        this.borderDashType = borderDashType;
        this.resetGhost();
    }

    setBorderWidth(borderWidth) {
        this.borderWidth = borderWidth;
        this.resetGhost();
    }

    getWidgetWrapper(isGhost = false) {
        var newShape = new shapeWidget(0, 0, 200, 200);

        newShape.mode = this.mode;
        newShape.color = this.color;

        if (lightOrDark(this.color) == "light") {
            newShape.textPart.menuTextColor("black", true);
        } else {
            newShape.textPart.menuTextColor("white", true);
        }


        newShape.borderColor = this.borderColor;
        newShape.borderDashType = this.borderDashType;
        newShape.borderWidth = this.borderWidth;

        var newGroup = new Group(true, isGhost);
        newShape.setParent(newGroup);
        return newGroup;
    }

    createShape() {
        var pt = canv.actionManager.getActionPoint();

        var creationStartX = pt.x;
        var creationStartY = pt.y;


        var newGroup = this.getWidgetWrapper();
        canv.canvasController.addGroup(newGroup);

        newGroup.translateGroup(creationStartX - newGroup.startX, creationStartY - newGroup.startY);


        canv.eventManager.openRecord();
        canv.eventManager.createBuildEvent("create", newGroup);
        canv.eventManager.closeRecord();

        canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(newGroup);
    }

    resetGhost() {
        this.ghost = null;
    }



    TryAction(type) {
        // если сразу сделать mouseup не дождавшись mousemove,
        // ghost тоже должен быть, т.к. появились хоткеи для фигур и
        // пользователь может не начать двигать курсор, а начать сразу создавать фигуру
        if (this.ghost == null) {
            this.ghost = this.getWidgetWrapper(true);
        }

        if (type == "mousedown") {
            this.clickMove = 1;

            var pt = canv.actionManager.getActionPoint();
            this.creationStartX = pt.x;
            this.creationStartY = pt.y;

        } else if (type == "mousemove") {
            if (this.ghost == null) {
                this.ghost = this.getWidgetWrapper(true);
            }

            if (this.clickMove > 0) {
                this.clickMove++;
            }

            if (this.clickMove == 0) {
                var pt = canv.actionManager.getActionPoint();

                var translateX = pt.x - this.ghost.startX;
                var translateY = pt.y - this.ghost.startY;
                this.ghost.translateGroup(translateX, translateY);
            } else if (this.clickMove > 2) {
                if (this.ghost == null) return;

                // Уменьшаем shape на 199, чтобы получилось width = 1, height = 1
                this.ghost.resizeGroup(-199, -199, "");

                const shape = this.ghost.children[0];

                canv.canvasController.addGroup(this.ghost);
                canv.eventManager.openRecord();
                canv.eventManager.createBuildEvent("create", this.ghost);
                canv.eventManager.closeRecord();

                var cursorTool = canv.toolBox.TryGetToolByName("cursorTool");
                selectionManager.setSelected([this.ghost], false);
                cursorTool.turnMode("resize");
                cursorTool.catchPointer = "bottomRight";

                shape.textPart.menuMobileEdit.bind(shape)(false);
            }


        } else if (type == "mouseup") {

            if (this.clickMove > 0 || this.clickMove <= 2)  {
                if (this.ghost == null) return;

                const shape = this.ghost.children[0];

                canv.canvasController.addGroup(this.ghost);
                canv.eventManager.openRecord();
                canv.eventManager.createBuildEvent("create", this.ghost);
                canv.eventManager.closeRecord();
                canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(this.ghost);

                shape.textPart.menuMobileEdit.bind(shape)(false);
            }

        }

        canv.redraw();
    }

    draw() {

        if (this.ghost == null) return;

        canv.ctx.globalAlpha = 0.2;
        this.ghost.draw();
        canv.ctx.globalAlpha = 1;
    }





    name = "shapeTool";
    ghost = null;

    clickMove = 0;
    creationStartX = 0;
    creationStartY = 0;

    mode = "rect";
    color = "#0c8de9";//"#3D62E1";
    borderColor = "transparent";
    borderDashType = "solid";
    borderWidth = 1;
}
